import { useMemo } from 'react';

import { AttachmentCategory, RichTextLexer, RichTextParser, SocialAttachment, VideoAttachment } from '@bonusly/common-action-input';

import { Bonus } from '../../../../../../types/bonus';
import { populateEmojis } from '../../../../../../utils/emoji';
import { LinkPreviewAttachment } from '../../../../../action-input/lib/entities/attachment';

export const useInitialState = (bonus?: Bonus) => {
	const initialState = useMemo(() => {
		if (!bonus) {
			return {};
		}

		const { attachments, reason } = bonus;

		const tokens = new RichTextLexer(populateEmojis(reason)).tokens();
		const content = new RichTextParser(tokens, bonus).document();

		const initialAttachment = (() => {
			if (!attachments || attachments.length === 0) {
				return null;
			}

			// Display the first attachment
			const data = attachments[0];
			switch (data.category) {
				case AttachmentCategory.Social:
					return new SocialAttachment({
						id: data.id,
						alt_text: data.alt_text,
						gif: data.gif,
						mp4: data.mp4,
						category: AttachmentCategory.Social,
					});
				case AttachmentCategory.Video:
					// FIXME Remove GenericAttachment and use VideoAttachmentAPIData and SocailAttachmentAPIData in monarch root
					return new VideoAttachment({
						id: data.id,
						name: data.name || '',
						video_id: data.video_id,
						video_thumbnail_url: data.video_thumbnail_url,
						video_poster_url: data.video_poster_url,
						video_transcript_url: data.video_transcript_url,
						video_hd_url: data.video_hd_url,
						video_sd_url: data.video_sd_url,
						video_original_url: data.video_original_url,
						category: AttachmentCategory.Video,
					});
				case AttachmentCategory.LinkPreview:
					return new LinkPreviewAttachment({
						id: data.id,
						category: AttachmentCategory.LinkPreview,
						url: data.url || '',
						title: data.title,
						description: data.description,
						image_url: data.image_url,
						site_name: data.site_name,
					});
				default:
					return new SocialAttachment({
						id: data.id,
						alt_text: data.alt_text,
						gif: data.gif,
						mp4: data.mp4,
						category: AttachmentCategory.Social,
					});
			}
		})();
		return {
			content,
			initialAttachment,
			initialIncludeGiver: bonus.include_parent_giver,
		};
	}, [bonus]);

	return initialState;
};
